<coso-page-header [title]="'Global Settings'"></coso-page-header>
<div class="row flex-xl-nowrap">
  <div class="col-12 col-md-3 col-xl-2 bd-sidebar">
    <nav class="bd-links" role="navigation" aria-label="Global Settings Navigation">
      <div role="tablist" class="bd-sidenav nav nav-pills flex-column mx-2" aria-orientation="vertical">
        @if (!isSaaS) {
        <a role="tab" class="nav-link align-items-center d-flex" routerLink="database-connections" routerLinkActive="active" aria-controls="panel" id="tab-database-connections">
          <span class="fa fa-database mx-2" aria-hidden="true"></span>Database connections
        </a>
        }
        <a role="tab" class="nav-link align-items-center d-flex" routerLink="email-notification-profiles" routerLinkActive="active" aria-controls="panel" id="tab-email-notification-profiles">
          <span class="fa fa-bell mx-2" aria-hidden="true"></span>Email notification profiles
        </a>
      </div>
    </nav>
  </div>
  <div class="col-12 col-md-9 col-xl-10 pl-md-5 bd-content" id="panel" role="tabpanel" tabindex="0">
    <router-outlet></router-outlet>
  </div>
</div>
